// UTC, not local time -- must match the recap card's own day boundary
// (getDailyKey/getStartOfDayTimestamp, both explicitly UTC). In timezones
// like Tanzania (UTC+3), local time can already be in tomorrow while the UTC
// day hasn't turned over yet, so using local time here could have the
// dashboard query a different calendar day than the recap card is showing.
export const getTodayDateString = (): string =>
    new Date().toISOString().slice(0, 10)
